var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogImageUrl)?_c('el-dialog',{staticClass:"previewDialog",attrs:{"visible":_vm.$parent.dialogVisible},on:{"update:visible":function($event){return _vm.$set(_vm.$parent, "dialogVisible", $event)}}},[_c('img',{attrs:{"src":_vm.dialogImageUrl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }